<div class="row">

  <div class="col-md-12">

    <div class="box" [ngClass]="{'box-primary': !this.isEditing, 'box-warning': this.isEditing }">

      <div class="box-header text-center">
        <h3 class="box-title ">Pesquisar por equipamento</h3><br />
        <span class="text-muted">Informe um ou mais parâmetros que serão combinados</span>
      </div>

      <div class="box-body">

        <form>
          <div class="form-row">
            <div class="col-md-1"></div>
            <div class="col-md-5">
              <div class="form-group">
                <label for="nome">Código (contém)</label>
                <input class="form-control parametro" type="text" maxlength="10" #nome />
              </div>
            </div>
            <div class="col-md-5">
              <div class="form-group">
                <label for="nome">Nº série (contém)</label>
                <input class="form-control parametro" type="text" maxlength="15" #numeroSerie />
              </div>
            </div>
          </div>

          <div class="form-row">
            <div class="col-md-1"></div>
            <div class="col-md-5">
              <div class="form-group">
                <label for="nome">Modelo (contém)</label>
                <input class="form-control parametro" type="text" maxlength="15" #modelo />
              </div>
            </div>
            <div class="col-md-5">
              <div class="form-group">
                <label for="">Tipo de equipamento</label>
                <select for="" class="form-control parametro" #tipoEquipamento>
                  <option value="">todos</option>
                  <option *ngFor="let t of this.tiposEquipamentos" [value]="t.id">{{ t.descricao }}</option>
                </select>
              </div>
            </div>
          </div>

          <div class="form-row">
            <div class="col-md-1"></div>
            <div class="col-md-5">
              <div class="form-group">
                <label for="">Fabricante</label>
                <select for="" class="form-control parametro" #fabricante>
                  <option value="">todos</option>
                  <option *ngFor="let t of this.fabricantes" [value]="t.id">{{ t.nome }}</option>
                </select>
              </div>
            </div>

            <div class="col-md-5">
              <div class="form-group">
                <label for="">Grupo Local</label>
                <select for="" class="form-control parametro" #grupoLocalNivel1Id>
                  <option value="">todos</option>
                  <option *ngFor="let t of this.gruposLocais" [value]="t.id">{{ t.nome }}</option>
                </select>
              </div>
            </div>

          </div>

          <div class="form-row">
            <div class="col-md-1"></div>
            <div class="col-md-5">
              <div class="form-group">
                <label for="">Classe equipamento</label>
                <select for="" class="form-control parametro" #classeEquipamentoId>
                  <option value="">todos</option>
                  <option *ngFor="let t of this.classesEquipamentos" [value]="t.id">{{ t.descricao }}</option>
                </select>
              </div>
            </div>

            <div class="col-md-2"></div>
            <div class="col-md-1">
              <label for="">&nbsp;</label>
              <button type="button" class="btn btn-secondary btn-block btn-shadow" (click)="limparParametros()"
                title="Limpar pesquisa"><i class="fa fa-trash"></i></button>
            </div>
            <div class="col-md-2">
              <label for="">&nbsp;</label>
              <button type="button" class="btn btn-primary btn-block  btn-shadow" (click)="buscar(
                      { 
                        'nome' : nome.value, 
                        'numeroSerie' : numeroSerie.value,
                        'modelo' : modelo.value,  
                        'tipoEquipamento' : tipoEquipamento.value,
                        'fabricanteId' : fabricante.value,
                        'grupoLocalNivel1Id': grupoLocalNivel1Id.value,
                        'classeEquipamentoId': classeEquipamentoId.value
                      })" title="Pesquisar por equipamentos">
                <i class="fa fa-search"></i>
              </button>
            </div>

          </div>



        </form>
      </div>
    </div>

  </div>

</div>

<div class="row">

  <div class="col-md-12">
    <div class="box" [ngClass]="{'box-primary': !this.isEditing, 'box-warning': this.isEditing }">

      <div class="box-body">

        <div class="row">

          <div class="col-md-9">

            <div class="box-header text-center">
              <h3 class="box-title ">Resultado da pesquisa</h3><br />
              <span class="text-muted">Selecione um equipamento ou imprima o plano de preventiva</span>
            </div>

            <div class="box-body" style="height: 283px;">

              <div class="box-table" style="height: 225px">
                <table>
                  <thead>
                    <tr>
                      <th class="text-center">Classe Equipamento</th>
                      <th class="text-center">Código</th>
                      <th class="text-center">Nº Série</th>
                      <th class="text-center">Descricao</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let rp of resultadosPesquisa" class="cp" (click)="getDetailsEquipamento(rp.id, rp.nome)"
                      [ngClass]="{'tr-foco': rp.id == this.equipamentoSelecionadoId, 'bg-destach': rp.qtdAtividades > 0}">
                      <td>{{ rp.classeEquipamentoStr }}</td>
                      <td>{{ rp.nome }}</td>
                      <td>{{ rp.numeroSerie }}</td>
                      <td>{{ rp.descricao }}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div class="text-left mt-2">
                <span class="pl-1">Total: <b>{{ this.resultadosPesquisa?.length }}</b> </span>

              </div>
            </div>

            <div class="text-center">
              <app-ball-pulse *ngIf="isProcessing"></app-ball-pulse>
            </div>


          </div>

          <div class="col-md-3 option-activ">

            <section>
              <p class="mb-0">Plano de 52 semanas</p>
              <div>
                <p>Ano</p>
                <input type="text" class="form-control text-center" style="width: 60%;" digitOnly maxlength="4"
                  [disabled]="this.resultadosPesquisa.length == 0" (keyup)="keyUpPlano($event.target.value)" />
              </div>
              <button type="button" style="width: 80%;" class="btn"
                [ngClass]="{'btn-secondary': this.anoProximaExecucao.length < 4, 'btn-primary': this.anoProximaExecucao.length > 3}"
                [disabled]="this.anoProximaExecucao.length < 4" (click)="getPlanoManutencaoExcel()">
                <span *ngIf="this.isGeneratingToExcel"
                  class="fa fa-spinner fa-lg fa-spin fa-fw pull-left text-white"></span>
                Extração do plano
              </button>
              <div class="row mt-1">
                <div class="col-md-12 text-center p-2 mb-1" [class.link-excel]="excelFileName !== ''">
                  <a *ngIf="excelFileName !== ''" [href]="hrefExcelFile" class="pl-2 pr-2 fb">{{excelFileName}}</a>
                </div>
              </div>

            </section>

            <section>
              <p>Equipamento Selecionado</p>
              <div>
                <p class="fb fs18 txt-blue">{{this.equipamentoSelecionado}}</p>
              </div>
              <button type="button" style="width: 80%;" class="btn"
                [ngClass]="{'btn-secondary': this.equipamentoSelecionado == '', 'btn-primary': this.equipamentoSelecionado != ''}"
                [disabled]="this.equipamentoSelecionado == ''"
                (click)="showModalGerarPlanoManutencao(modalPlanoManutencao)">Gera calendário preventiva
              </button>

            </section>

            <div>

            </div>
          </div>

        </div>
      </div>
    </div>
  </div>
</div>



<div class="row mt-1">
  <div class="col-md-12">
    <div class="box" [ngClass]="{'box-primary': !this.isEditing, 'box-warning': this.isEditing }">
      <div class="box-body">
        <div class="row">
          <div class="col-md-4">

          </div>
          <div class="col-md-4">
            <div class="d-flex justify-content-center">
              <a [routerLink]="['/home']" title="Tela Principal"><img src="./assets/images/homePeq.png" /></a>
            </div>
          </div>
          <div class="col-md-4">



          </div>

        </div>
      </div>
    </div>
  </div>
</div>



<!-- ---------------------- MODAL ------------            -->

<ng-template #modalPlanoManutencao let-c="close" let-d="dismiss">
  <div class="modal-header mh-primary">
    <h4 class="modal-title">Gerar calendário de preventivas</h4>
  </div>
  <div class="modal-body pt-0 mt-0" [ngClass]="{'tarja-edit': !this.modoInsercao}">


    <div class="row mt-3">

      <div class="col-md-1 box-left">
        <span class="material-icons icon-theme">
          build
        </span>
      </div>

      <div class="col-md-11">

        <div class="row">
          <div class="col-md-3"></div>
          <div class="col-md-6 text-center">
            <p class="text-muted">Criar atividades para o calendário de preventivas do seguinte período</p>
          </div>
        </div>

        <div class="row">

          <div class="col-md-3 text-center">
            <div class="row">
              <div class="col-md-12">
                <p class="text-muted mb-1">Equipamento selecionado</p>
                <span class="fb fs18 txt-blue">{{this.equipamentoSelecionado}}</span>
              </div>
            </div>

          </div>

          <div class="col-md-6">

            <div class="row">

              <div class="col-md-6">
                <div class="form-group">
                  <label for="">Data Inicial</label>
                  <input class="form-control" type="date" id="inputDataInicio" max="2999-12-31"
                    [ngClass]="{'h-error' : validaDataInicio != ''}">
                  <div class="col-md-12 text-text">
                    <span *ngIf="validaDataInicio !=''" class="txt-danger-fb pl-1">{{this.validaDataInicio}}</span>
                  </div>
                </div>

              </div>

              <div class="col-md-6">
                <div class="form-group">
                  <label for="">Data Final</label>
                  <input class="form-control" type="date" id="inputDataTermino" max="2999-12-31"
                    [ngClass]="{'h-error' : validaDataTermino != ''}">
                  <div class="col-md-12 text-center">
                    <span *ngIf="validaDataTermino!=''" class="txt-danger-fb">{{this.validaDataTermino}}</span>
                  </div>
                </div>
              </div>
            </div>

          </div>

          <div class="col-md-3 text-center">
            <p class="mb-2">Aplicar filtro (descrição rotina)</p>
            <div class="input-group">
              <input class="form-control" type="text" id="inputFiltro" maxlength="40" tabindex="-1"
                (keyup)="filtrarAtividades($event.target.value)" [disabled]="this.equipamentoSelecionadoId == 0">
              <div class="input-group-append cp" (click)="clearFiltro()" title="Limpar filtro">
                <span class="input-group-text"><i class="fa fa-trash"></i></span>
              </div>
            </div>
          </div>
        </div>

        <div class="divider"></div>

        <div style="display: flex; justify-content:space-between; ">
          <div style="width: 40px; display: flex; flex-direction: column;">
            <div class="fa fa-lg fa-sort-alpha-asc mb-3 mt-1 cp" title="Mostrar rotinas padrão em ordem alfabética"
              (click)="OrderByAtividades(true)"
              [ngClass]="{'text-info' : this.orderByRotina, 'text-muted' : !this.orderByRotina}"></div>
            <div class="fa fa-lg fa-calendar-o cp" title="Mostrar rotinas com plano de execução primeiro"
              (click)="OrderByAtividades(false)"
              [ngClass]="{'text-info' : !this.orderByRotina, 'text-muted' : this.orderByRotina}"></div>
          </div>

          <div class="bx-tb-default-t1 pre-scrollable" style="min-height: 520px; max-height: 520px; width: 100%;">
            <table class="table table-bordered">

              <thead class="thead-default">
                <tr>
                  <th class="text-center wf120">Área técnica</th>
                  <th class="text-center wf180">Rotina padrão</th>
                  <th class="text-center wf120">Periodicidade</th>
                  <th class="text-center th-prox-exec">Próxima(s) execução(ções)</th>
                </tr>
              </thead>

              <tbody class="tbody-default">
                <tr *ngFor="let a of this.atividadesFilters;  let i = index;" [ngClass]="{'tr-foco': a.proximasExecucoes}">

                  <td class="text-center td-middle">{{ a.areaTecnica }}</td>
                  <td class="td-middle">{{a.rotinaCodigo}} - {{ a.rotinaPadrao }}</td>
                  <td class="text-center td-middle">{{ a.espacamento }}</td>


                  <td *ngIf="a?.proximasExecucoes" class="text-center">
                    <table class="table table-bordered table-hover">
                      <tr *ngFor="let e of a.proximasExecucoes;">
                        <td class="text-center td-middle" style="padding: 2px; height: 7px;">
                          <span style="display: flex; justify-content: space-around;">
                            <span [ngClass]="{'txt-danger fb': e.ds == 1 || e.ds == 7}"> {{e.proximaExecucao | date:
                              'dd/MM/yyyy'}}</span>
                            <span>{{dayWeeksOrd[e.ds]}}</span>
                          </span>
                        </td>
                        <td style="width: 60px;" class="td-middle text-center bg-light cp"
                          [ngClass]="{'txt-blue': e.osId == null, 'text-warning': e.osId != null}"
                          style="padding: 2px; height: 7px;" title="Editar data"
                          (click)="editDataProximaExecucao(a, e, modalEditDataProximaExecucao)">
                          <span class="fa fa-edit"></span>
                        </td>
                      </tr>
                    </table>

                    <div style="display: flex; flex-flow: row nowrap; justify-content: space-between;">
                      <button type="button" class="btn btn-light mr-5" (click)="removerPlanoManutencao(a, modaldelete)"><span
                          class="fa fa-trash txt-danger"></span></button>

                      <div class="input-group" style="flex: 1;">
                        <input type="date" class="form-control" id="inputDateNewDataExecucao{{i}}"  max="2999-12-31" />
                        <div class="input-group-append cp" (click)="alteraPlanoExecucao(i, a)"
                          title="Editar calendário de preventivas">
                          <span class="input-group-text"
                            style="padding-left: 10px !important; padding-right: 10px !important; ">
                            <i class="fa fa-calendar-check-o txt-blue"></i>
                          </span>
                        </div>
                      </div>

                    </div>
                  </td>

                  <td class="text-center" *ngIf="!a?.proximasExecucoes">
                    <input class="form-control" type="date" #proximaExecucao max="2999-12-31"
                      (blur)="UpdateProximaExecucao(proximaExecucao.value, a.periodicidadeId)" />
                  </td>
                </tr>

              


              </tbody>
            </table>
          </div>


        </div>


        <div *ngIf="this.atividades.length != 0" class="pl-2 mt-1" style="margin-left: 40px;">
          <span class="pl-1">Total: <b>{{ this.atividadesFilters.length}}</b> </span>
          <span *ngIf="this.atividades.length > this.atividadesFilters.length"
            class="pl-3 text-primary">(filtrados)</span>
        </div>


      </div>

    </div>







  </div>
  <div class="modal-footer">
    <div class="row">
      <div class="col-md-6"></div>
      <div class="col-md-6">
        <div class="d-flex justify-content-end">
          <button type="button" class="btn btn-light pl-5 pr-5 mr-3" (click)="c('Close click')">Retornar</button>
          <button type="button" class="btn btn-primary pl-5 pr-5 mr-2" 
          [disabled]="this.nenhumDataProximaExecucao()" (click)="submit()">
          Salvar
        </button>
        </div>
      </div>
    </div>
  </div>
</ng-template>





<ng-template #modalEditDataProximaExecucao let-c="close" let-d="dismiss">
  <div class="modal-header mh-primary">
    <h4 class="modal-title">Editar data de próxima execução</h4>
  </div>
  <div class="modal-body pt-0 mt-0 tarja-edit">
    <div class="row mt-2">

      <div class="col-md-12 edit-atividade">

        <table class="table table-bordered edit-atividade" style="border: 2px solid #bbb;">

          <tr>
            <th>Área técnica</th>
            <td>{{atividadeSelecionada.areaTecnica}}</td>
          </tr>

          <tr>
            <th>Rotina padrão</th>
            <td>{{atividadeSelecionada.rotinaPadrao}}</td>
          </tr>

          <tr>
            <th>Periodicidade</th>
            <td>{{atividadeSelecionada.espacamento}}</td>
          </tr>



          <tr>
            <th>Próxima execução (atual)</th>
            <td
              [ngClass]="{'txt-danger fb': this.dayWeek == 'SÁB' || this.dayWeek == 'DOM' , 'txt-blue': !(this.dayWeek == 'SÁB' || this.dayWeek == 'DOM') }">
              {{proximaExecucaoSelecionada | date: "dd/MM/yyyy"}} ({{this.dayWeek}})</td>
          </tr>

          <tr>
            <th>OS emitida</th>
            <td *ngIf="osIdSelecionada != null" class="cp">
              <section style="display: flex; justify-content: space-between; align-items: center; ">
                <span>{{osIdSelecionada}}</span>
                <app-ball-pulse *ngIf="isReprintOS"></app-ball-pulse>
                <span class="fa fa-print fa-lg txt-blue" (click)="reimprimirOS(true, osIdSelecionada)"
                  title="reimprimir OS"></span>
              </section>
            </td>

            <td *ngIf="osIdSelecionada == null">
              --
            </td>
          </tr>

        </table>

        <div style="width: 100%; border-top: 2px solid #ddd; margin: 20px 0;"></div>

        <section *ngIf="osIdSelecionada == null">
          <div class="form-row">
            <div class="col-md-3"></div>
            <div class="col-md-6">
              <div class="form-group text-center">
                <label for="nome">Nova data próxima execução</label>
                <input class="form-control" type="date" id="inputNovaDataProximaExecucao" max="2999-12-31"
                  [ngClass]="{'h-error' : validaNovaDataProximaExecucao != ''}">
              </div>
            </div>

          </div>
          <div class="row">
            <div class="col-md-11 text-center mt-2">
              <span *ngIf="validaNovaDataProximaExecucao !=''"
                class="text-danger pl-5">{{this.validaNovaDataProximaExecucao}}</span>
            </div>
          </div>
        </section>

        <section *ngIf="osIdSelecionada != null">


          <div class="mh-warning p-2" style="border-radius: 4px;">
            <div style="display: flex; justify-content: space-around; align-items: center;">
              <span class="fa fa-warning fa-lg"></span>
              <span>Não é possível editar a atual data de próxima execução <br />porque uma OS correspondente já foi
                emitida.</span>


            </div>
          </div>



        </section>

      </div>
    </div>
  </div>
  <div class="modal-footer">
    <div class="row">
      <div class="col-md-6"></div>
      <div class="col-md-6">
        <div class="d-flex justify-content-end">
          <button type="button" class="btn btn-light pl-5 pr-5 mr-3" (click)="c('Close click')">Cancelar</button>
          <button type="button" class="btn btn-primary btn-shadow pl-5 pr-5 mr-2" *ngIf="osIdSelecionada == null"
            (click)="updateDataProximaExecucao(c)">Confirmar</button>
        </div>
      </div>
    </div>
  </div>
</ng-template>





<ng-template #modalEditPlanoProximaExecucao let-c="close" let-d="dismiss">
  <div class="modal-header mh-primary">
    <h4 class="modal-title">Editar plano de execução</h4>
  </div>
  <div class="modal-body pt-0 mt-0 tarja-edit">
    <div class="row mt-2">

      <div class="col-md-12 edit-atividade">

        <table class="table table-bordered edit-atividade" style="border: 2px solid #bbb;">

          <tr>
            <th>Área Técnica</th>
            <td>{{atividadeSelecionada.areaTecnica}}</td>
          </tr>

          <tr>
            <th>Rotina padrão</th>
            <td>{{atividadeSelecionada.rotinaPadrao}}</td>
          </tr>

          <tr>
            <th>Periodicidade</th>
            <td>{{atividadeSelecionada.espacamento}}</td>
          </tr>

        </table>

        <div style="width: 100%; border-top: 2px solid #ddd; margin: 20px 0;"></div>

        <div class="form-row">
          <div class="col-md-12">



            <div class="row mb-3">
              <div class="col-md-12 text-center">
                <p class="text-muted">Criar novo período de calendário de preventivas e substuir o atual</p>

                <section class="mt-2" *ngIf="this.hasSomeOsIdSelecionada">
                  <div class="mh-warning p-2" style="border-radius: 5px;">
                    <div style="display: flex; justify-content: space-around; align-items: center;">
                      <span><span class="fa fa-warning fa-lg pr-2"></span><span>Atenção</span></span>
                      <span>O novo calendário não afetará as datas <br />para as quais já foram emitidas OSs.</span>
                    </div>
                  </div>
                </section>


              </div>
            </div>


            <div class="row">

              <div class="col-md-6">
                <div class="form-group">
                  <label for="">Data Inicial</label>
                  <input class="form-control" type="date" id="inputDataInicioNovoPlano" max="2999-12-31" 
                    [ngClass]="{'h-error' : validaDataInicioNovoPlano != ''}">
                  <div class="col-md-12 text-text">
                    <span *ngIf="validaDataInicioNovoPlano !=''"
                      class="text-danger pl-5">{{this.validaDataInicioNovoPlano}}</span>
                  </div>
                </div>

              </div>

              <div class="col-md-6">
                <div class="form-group">
                  <label for="">Data Final</label>
                  <input class="form-control" type="date" id="inputDataTerminoNovoPlano" max="2999-12-31"
                    [ngClass]="{'h-error' : validaDataTerminoNovoPlano != ''}">
                  <div class="col-md-12 text-center">
                    <span *ngIf="validaDataTerminoNovoPlano!=''"
                      class="text-danger">{{this.validaDataTerminoNovoPlano}}</span>
                  </div>
                </div>
              </div>
            </div>


          </div>

        </div>

        <!--     <div class="row">
          <div class="col-md-11 text-center mt-2">
            <span *ngIf="validaNovaDataProximaExecucao !=''" class="text-danger pl-5">{{this.validaNovaDataProximaExecucao}}</span>
          </div>
        </div> -->


        <div style="width: 100%; border-top: 2px solid #ddd; margin: 20px 0;"></div>

        <div class="form-row">
          <div class="col-md-3"></div>
          <div class="col-md-6">
            <div class="form-group text-center">
              <label for="nome">Data próxima execução</label>
              <input class="form-control" type="date" id="inputNovaDataPlanoProximaExecucao" max="2999-12-31"
                [ngClass]="{'h-error' : validaNovaDataPlanoProximaExecucao != ''}">
            </div>
          </div>

        </div>
        <div class="row">
          <div class="col-md-11 text-center mt-2">
            <span *ngIf="validaNovaDataPlanoProximaExecucao !=''"
              class="text-danger pl-5">{{this.validaNovaDataPlanoProximaExecucao}}</span>
          </div>
        </div>






      </div>
    </div>
  </div>
  <div class="modal-footer">
    <div class="row">
      <div class="col-md-6"></div>
      <div class="col-md-6">
        <div class="d-flex justify-content-end">
          <button type="button" class="btn btn-light pl-5 pr-5 mr-3" (click)="c('Close click')">Cancelar</button>
          <button type="button" class="btn btn-primary btn-shadow pl-5 pr-5 mr-2"
            (click)="updatePlanoProximasExecucoes(c)">Confirmar</button>
        </div>
      </div>
    </div>
  </div>
</ng-template>



<ng-template #modaldelete let-c="close" let-d="dismiss">
  <div class="modal-header">
    <h4 class="modal-title">SIGEM CLOUD</h4>
  </div>
  <div class="modal-body">
    <div class="row">
      <div class="col-md-3">
        <div class="d-flex justify-content-center">
          <img src="assets\images\icon-question.png" />
        </div>
      </div>
      <div class="col-md-9">
        <div class="alert alert-warning">
          <div class="text-center">
            <span class="question-modal pt-3 pb-3">Deseja remover o <br /><b>Calendário de
                Preventivas</b><br />selecionado?</span>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="modal-footer">
    <div class="row">
      <div class="col-md-6"></div>
      <div class="col-md-6">
        <div class="d-flex justify-content-end">
          <button type="button" class="btn btn-light pl-5 pr-5 mr-3" (click)="c('Close click')">Não</button>
          <button type="button" class="btn btn-primary btn-shadow pl-5 pr-5 mr-2" (click)="delete(c)">Sim</button>
        </div>
      </div>
    </div>
  </div>
</ng-template>